export default defineNuxtPlugin((nuxtApp) => {
  let logstoreModulePromise = null

  function sendLog(eventType, otherParams = {}) {
    if (!import.meta.client) return
    if (!logstoreModulePromise) {
      logstoreModulePromise = import('@/utils/logstore')
    }
    logstoreModulePromise
      .then((module) => module.sendLog?.(eventType, otherParams))
      .catch((error) => {
        if (import.meta.dev) {
          console.warn('[logstore] failed to load ~/utils/logstore', error)
        }
      })
  }

  nuxtApp.provide('sendLog', sendLog)
})
